import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

import { environment } from '../../../environments/environment';
import { HomeService } from '../../services/home.service';
import { DateTimeService } from '../../services/date-time.service';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-home-selector',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  @HostBinding('class.homeHost') hostClass = false;
  public showLoader = false;
  public environment = environment;
  featuredImages = [];
  categories = [];
  localStSub;
  sliderImage = '';
  public slideConfig = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    swipe: true,
    cssEase: 'linear',
    mobileFirst: true,
  };

  ngOnInit() {
    window.scrollTo(0, 0);
    setTimeout(_ => {
      this.localSt.store('pastOrderAgain', false);
    });
    if (!this.localSt.retrieve('editOrderAddingAnotherItem') || this.localSt.retrieve('editOrderAddingAnotherItem') === false) {
      this.localSt.clear('subHeaderHeading');
      this.localSt.clear('backButton');
    }
    if (this.localSt.retrieve('editOrderAddingAnotherItem') || this.localSt.retrieve('editOrderAddingAnotherItem') === true) {
      this.localSt.store('backButton', { show: true, title: 'Edit Order', link: '/orders/edit/' + this.localSt.retrieve('orderNumber') });
    }
    this.getFeaturedImagesAndCategories(this.dateTimeService.getSelectedDate());

    this.localStSub = this.localSt.observe('selectedDate').subscribe((data) => {
      this.getFeaturedImagesAndCategories(data.fullDate);
    });

    this.localSt.observe('homeRefresh').subscribe(() => {
      this.getFeaturedImagesAndCategories(this.dateTimeService.getSelectedDate());
    });

    this.localSt.observe('myCartSelectedDate').subscribe((status) => {
      if (status) { window.scrollTo(0, 0); }
    });

    this.localSt.observe('addAnotherDelivery').subscribe((status) => {
      if (status) { window.scrollTo(0, 0); }
    });
  }

  constructor(
    private homeAPIs: HomeService,
    private localSt: LocalStorageService,
    private dateTimeService: DateTimeService,
    private titleService:Title) {
    this.hostClass = true;
    this.titleService.setTitle("Order Z.E.N. Classics - Menu");
  }

  getFeaturedImages() {
    this.showLoader = true;
    this.homeAPIs.featuredImages().subscribe((res) => {
      this.showLoader = false;
      this.featuredImages = res.data;
    });
  }

  getCategories() {
    this.homeAPIs.categoriesListing().subscribe((res) => {
      this.categories = res.data;
    });
  }

  getFeaturedImagesAndCategories(date) {
    this.localSt.store('loaderSetting', { showLoader: true });
    this.homeAPIs.featuredImagesAndCategories(date).subscribe((res) => {
      this.featuredImages = res.data.features;
      this.sliderImage = this.featuredImages && this.featuredImages.length ? this.featuredImages[0].zf_image_web : null;
      this.categories = res.data.categories;
      this.localSt.store('loaderSetting', { showLoader: false });
    });
  }

  replaceSpecialChars(str) {
    return str.replace(/\//gi, '-slash-');
  }

  ngOnDestroy() {
    this.localStSub.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/home/home.component.ts